import { Injectable } from '@angular/core';
import { MdbTabsComponent } from 'mdb-angular-ui-kit/tabs';
import { MdbTabChange } from 'mdb-angular-ui-kit/tabs/tabs.component';
import { EventTabsStepService } from './event-tabs-step.service';

@Injectable({
  providedIn: 'root'
})
export class EventTabsService {
  private _status = false;
  set status(status: boolean) {
    this._status = status;
    this.eventTabsStepService.status = status;
  }

  get status() {
    return this._status;
  }

  private _tabs: MdbTabsComponent = null;

  set tabs(tabs: MdbTabsComponent) {
    this._tabs = tabs || null;
    if (this._tabs == null) {
      this.status = false;
      return;
    }
    this.status = true;

    if (this.eventTabsStepService.step > 0) {
      this.setActiveTab(this.eventTabsStepService.step);
    }
  }

  get tabs(): MdbTabsComponent {
    return this._tabs;
  }

  set step(step: number) {
    this.eventTabsStepService.step = step;
  }

  get step() {
    return this.eventTabsStepService.step;
  }

  set firstStep(firstStep: number) {
    this.eventTabsStepService.firstStep = firstStep;
  }

  get firstStep() {
    return this.eventTabsStepService.firstStep;
  }

  set lastStep(lastStep: number) {
    this.eventTabsStepService.lastStep = lastStep;
  }

  get lastStep() {
    return this.eventTabsStepService.lastStep;
  }

  constructor(
    private eventTabsStepService: EventTabsStepService,
  ) {
    this.eventTabsStepService.onPreviousStepSubject.subscribe(() => {
      this.previousStep();
    });
    this.eventTabsStepService.onNextStepSubject.subscribe(() => {
      this.nextStep();
    });
  }

  onTabChange(event: MdbTabChange, isFormValid) {
    switch (event.index) {
      case 5:
        if (!isFormValid) {
          this.setActiveTab(this.step);
          return;
        }
      case 4:
        if (!isFormValid) {
          this.setActiveTab(this.step);
          return;
        }
      case 3:
        if (!isFormValid) {
          this.setActiveTab(this.step);
          return;
        }
      case 2:
        if (!isFormValid) {
          this.setActiveTab(this.step);
          return;
        }
      case 1:
        if (!isFormValid) {
          this.setActiveTab(this.step);
          return;
        }
      case 0:
        this.step = event.index;
    }
    return;
  }

  setActiveTab(index: number) {
    if (this.status) {
      this._tabs.setActiveTab(index);
      this.step = index;
    }
  }

  previousStep() {
    if (this.step > this.firstStep) {
      return this.setActiveTab(this.step - 1);
    }
    return null;
  }

  nextStep() {
    if (this.step < this.lastStep) {
      return this.setActiveTab(this.step + 1);
    }
    return null;
  }

  reset() {
    this.status = false;

    this._tabs = null;

    this.eventTabsStepService.reset();
  }
}
